export const CALENDAR_ROUTE = "/{service_company_slug}/calendar/"
